import React, { useEffect, useState } from 'react'
import ReactDom from 'react-dom'
import { useFireStore } from '../../firebase/firebase'
import { useAuth } from 'context/AuthContext'
import { Picker } from 'emoji-mart'
import 'emoji-mart/css/emoji-mart.css'

import { Close } from 'components/misc/Icons'

export default function ModalEmoji({ open, onClose, id, tag }) {

    const { currentUser } = useAuth()

    const setEmoji = async (e) => {
        let emoji = e.native;
        await useFireStore.collection("tagIcons")
        .doc(currentUser.uid)
        .set({
            [tag]: emoji
        },{merge:true});
        onClose();
    };

    if (!open) return null

    return ReactDom.createPortal(
        <div className="fixed top-0 bottom-0 left-0 right-0 bg-lightbg dark:bg-darkbg z-1100">
            <div className="fixed flex justify-center w-full h-full p-4 rounded z-1100 bg-lightbg dark:bg-darkbg" style={{top: '50%',left: '50%',transform: 'translate(-50%, -50%)'}}>
                <button onClick={onClose} className="absolute top-0 right-0 w-8 h-8 mt-4 mr-4 text-black focus:outline-none">
                    <Close/>
                </button>

                <div className="hidden dark:block">
                    <Picker
                        onSelect={setEmoji}
                        title='Pick a topic emoji…'
                        emoji='point_up'
                        style={{height:"428px", marginTop:"40px"}}
                        theme={'dark'}
                    />
                </div>
                <div className="block dark:hidden">
                    <Picker
                        onSelect={setEmoji}
                        title='Pick a topic emoji…'
                        emoji='point_up'
                        style={{height:"428px", marginTop:"40px"}}
                        theme={'light'}
                    />
                </div>

            </div>
        </div>,

        document.getElementById('portal')
    )
}
